// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"250":"362c7000","357":"fde27a35","372":"fde27a35","879":"ea926a7b"}[chunkId] + ".chunk.css";
};